import useRouter from "@hooks/useRouter"

import { faIcon } from "@utils/faIcon"
import isModKeyPressed from "@utils/isModKeyPressed"

import { EmptyState } from "@molecules"

import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"
import styles from "@organisms/ObjectsView/TableView/TableViewEdgeStates/TableViewEdgeStates.module.scss"
import TableViewLoadingState, {
    GRAPHIC_ROWS_COUNT,
} from "@organisms/ObjectsView/TableView/TableViewEdgeStates/TableViewLoadingState/TableViewLoadingState"

import { objectMap } from "@constants/objectMap"

import { TableViewEmptyStateProps } from "./TableViewEmptyState.types"

export default function TableViewEmptyState(props: TableViewEmptyStateProps) {
    const { children } = props

    const { push } = useRouter()

    const { tabContentName, objectCreateRoute, objectType, isEmptyStateCreateButtonVisible } = useObjectsView()

    // e.g. "All Open Credit Notes" -> "No open credit notes" / "There are no open credit notes to display".
    const listName = tabContentName.toLowerCase().replace("all", "").replace("&", "or").trim()

    const onCreateClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (isModKeyPressed(event)) {
            window.open(objectCreateRoute, "_blank", "noopener,noreferrer")
        } else {
            push(objectCreateRoute)
        }
    }

    return (
        <>
            {children}
            <div className={styles.base}>
                <TableViewLoadingState isAnimated={false} isBackground={true} numberOfRows={GRAPHIC_ROWS_COUNT} />
                <EmptyState
                    variant="default"
                    icon={objectMap[objectType].iconActive}
                    title={`No ${listName}`}
                    supportText={`There are no ${listName} to display`}
                    primaryCTA={
                        isEmptyStateCreateButtonVisible
                            ? {
                                  children: "Create",
                                  leftIcon: faIcon({ name: "plus", style: "regular" }),
                                  onClick: onCreateClick,
                                  noDebounce: true,
                              }
                            : undefined
                    }
                />
            </div>
        </>
    )
}
